import {LineConsommation} from '../consommation/lineConsommation.interface';

export namespace LineFolders {
  export interface LineFolderInterface extends LineConsommation.LineConsommationInterface {
    rsfNomFournisseur?: string;
    rsfDateFacture?: string;
    rsfNombreUniteFacture?: number;
    rsfNombreUnitePrisEnCompte?: number;
    rsfMontantUniteFacture?: number;
    rsfMontantUnitePrisEnCompte?: number;
    rsfTotalUnitesPresente?: number;
    rsfTotalUnitesPrisEnCompte?: number;
    rsfMontantFacture?: number;
    rsfMontantFacturePrisEnCompte?: number;
    statutAdministratif: LineFolders.StatutAdministratifEnum;
    montant?: number;
  }

  export type StatutAdministratifEnum = 'ATT' | 'VAL' | 'REF';

  export const StatutAdministratifEnum = {
    Attente: 'ATT' as StatutAdministratifEnum,
    Valide: 'VAL' as StatutAdministratifEnum,
    Refuse: 'REF' as StatutAdministratifEnum
  };

  /**
   * According to the states the reimbursement line is editable or not
   * @param {FolderType.LineFolderInterface} line
   * @returns {boolean}
   */
  export function isEditable(line: LineFolderInterface): boolean {
    return LineFolders.StatutAdministratifEnum.Attente === line.statutAdministratif;
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/folder/lineFolder.interface.ts